import React, { useState } from "react";
import FormField from "../FormField/FormField";
import ProgressBar from "../../Components/ProgressBar/ProgressBar";
import shared from "../../styles/shared.module.css";
import {
  undergradFields,
  graduateOpportunityTypeField,
  graduateWorkFieldField,
  getGraduateNationField,
  graduateTravelTimeField,
} from "../../data/formFields";
import { validateFields } from "../../Utilities/validateStep";

function Step2({ data, updateData, onNext, onBack }) {
  const isUndergrad = data.educationLevel === "undergraduate";
  const [errors, setErrors] = useState([]);

  const graduateFields = [
    graduateOpportunityTypeField,
    graduateWorkFieldField,
    ...(Array.isArray(data.opportunityType) ? data.opportunityType : [])
      .map(getGraduateNationField)
      .filter(Boolean),
    graduateTravelTimeField,
  ];
  const activeFields = isUndergrad ? undergradFields : graduateFields;

  const handleSubmit = (e) => {
    e.preventDefault();
    const fieldErrors = validateFields(activeFields, data);
    if (fieldErrors.length > 0) {
      setErrors(fieldErrors);
      return;
    }
    setErrors([]);
    onNext();
  };

  const renderField = (field) => (
    <div key={field.name} className={shared.questionCard}>
      <FormField
        field={field}
        value={data[field.name]}
        otherValue={data[`${field.name}Other`]}
        onChange={updateData}
      />
    </div>
  );

  return (
    <>
      {isUndergrad ? (
        <>
          <h1 className={shared.pageHeading}>GLOBAL VOLUNTEER</h1>
          <p className={shared.pageSubheading}>
            AIESEC's Global Volunteer program connects undergraduate students with sustainable development
            projects worldwide, turning classroom knowledge into real-world impact. Join thousands of young
            changemakers across 125+ countries and territories, build leadership skills, and discover your
            purpose through meaningful international service.
          </p>
        </>
      ) : (
        <>
          <h1 className={shared.pageHeading} style={{ fontWeight: 700 }}>GLOBAL OPPORTUNITIES</h1>
          <p className={shared.pageSubheading}>
            AIESEC's Global Opportunity programs for graduates offer three pathways to global impact: volunteer
            on development projects, intern with international organizations, or teach and mentor students
            abroad, all while building leadership skills and meaningful networks across 125+ countries and
            territories.
          </p>
        </>
      )}
      <ProgressBar currentStep={2} totalSteps={3} />

      <form onSubmit={handleSubmit}>
        <div className={shared.cardStack}>{activeFields.map(renderField)}</div>

        {errors.length > 0 && (
          <ul className={shared.errorList}>
            {errors.map((err) => <li key={err}>{err}</li>)}
          </ul>
        )}

        <div className={shared.navRow}>
          <button type="button" className={shared.secondaryButton} onClick={onBack}>← Back</button>
          <button type="submit" className={shared.primaryButton}>Continue →</button>
        </div>
      </form>
    </>
  );
}

export default Step2;
